import Vue from "vue";
import Vuex from "vuex";
import vuexAlong from "vuex-along";
import {loginCellphone, userDetail, logout} from "@/api";

Vue.use(Vuex);

const userAbout = {
  namespaced: true,
  state: {
    // 从 sessionStorage 恢复数据，刷新页面不会丢失
    userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
    isLogin: !!sessionStorage.getItem('token'),
  },
  actions: {
    async userLogin({commit}, data) {
      let result = await loginCellphone(data);
      console.log("result=========", result);
      if (result.code === 200) {
        window.sessionStorage.setItem('token', result.data.token)
        window.sessionStorage.setItem('loginType', result.data.type)
        let result2 = await userDetail()
        commit("USERLOGIN", result2.data);
        console.log("result=========", result.data.token);

        return "OK";
      }
    },

    // 退出登录
    async userLogout({commit}) {
      console.log("userLogout=========")
      // let result = await logout()
      // if (result.data.code === 200) {
        commit("USERLOGOUT")
        window.sessionStorage.setItem('token', '')
        window.sessionStorage.setItem('loginType', '')
        // return "OK"
      // }
    }
  },
  mutations: {
    USERLOGIN(state, data) {
      Vue.set(state, "userInfo", data);
      Vue.set(state, "isLogin", true);
      // 保存到 sessionStorage，刷新页面后恢复
      sessionStorage.setItem('userInfo', JSON.stringify(data));
    },
    USERLOGOUT(state) {
      state.isLogin = false
      state.userInfo = {}
      // 清除 sessionStorage
      sessionStorage.removeItem('userInfo')
    }
  },
  getters: {
    // 用户关注数
    follows(state) {
      return state.userInfo.profile ? state.userInfo.profile.follows : "";
    },
    // 用户粉丝数
    followeds(state) {
      return state.userInfo.profile ? state.userInfo.profile.followeds : 0;
    },
    // 用户头像
    userAvatarUrl: state => state.userInfo.profile ? state.userInfo.profile.avatarUrl : "",
    // 用户动态
    userEventCount: state => state.userInfo.profile ? state.userInfo.profile.eventCount : 0,
    // 用户昵称
    userNickname: state => state.userInfo.profile ? state.userInfo.profile.nickname : "",
    // 用户等级
    userLevel: state => state.userInfo.level || 0,
  }
};

export default new Vuex.Store({
  modules: {
    userAbout,
  },
  plugins: [vuexAlong]
});
